(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cinematic"] && !Shopify.designMode) return;
  try {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const supported = 'IntersectionObserver' in window && !reduce;

  const observer = supported
    ? new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (!entry.isIntersecting) continue;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
      )
    : null;

  const arm = (root) => {
    const nodes = root.querySelectorAll('[data-reveal]:not([data-reveal-armed])');
    const fold = window.innerHeight;
    nodes.forEach((node, index) => {
      node.setAttribute('data-reveal-armed', '');
      if (!observer) return;
      // Anything already on screen stays put; only below-the-fold content animates in.
      if (node.getBoundingClientRect().top > fold) {
        const delay = Number(node.getAttribute('data-reveal')) || 0;
        node.style.setProperty('--reveal-delay', `${delay}ms`);
        node.classList.add('cine-reveal');
        observer.observe(node);
      }
    });
  };

  arm(document);
  document.addEventListener('shopify:section:load', (event) => arm(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["contact-status"] && !Shopify.designMode) return;
  try {
    const TIME_ZONE = 'Europe/Amsterdam';
  const DAY_INDEX = { Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6, Sun: 7 };

  const now = () => {
    const parts = new Intl.DateTimeFormat('en-US', {
      timeZone: TIME_ZONE,
      weekday: 'short',
      hour: '2-digit',
      minute: '2-digit',
      hourCycle: 'h23',
    }).formatToParts(new Date());
    const get = (type) => (parts.find((part) => part.type === type) || {}).value || '';
    return { day: DAY_INDEX[get('weekday')] || 0, time: `${get('hour')}:${get('minute')}` };
  };

  const update = (node) => {
    const days = (node.dataset.days || '').split(',').map((d) => Number(d)).filter(Boolean);
    const open = node.dataset.open || '';
    const close = node.dataset.close || '';
    if (!days.length || !/^\d{2}:\d{2}$/.test(open) || !/^\d{2}:\d{2}$/.test(close)) return;

    const current = now();
    const isOpen = days.includes(current.day) && current.time >= open && current.time < close;
    const text = isOpen ? node.dataset.labelOpen : node.dataset.labelClosed;
    node.classList.toggle('is-open', isOpen);
    node.classList.toggle('is-closed', !isOpen);
    const label = node.querySelector('.contact-status__label');
    if (label) label.textContent = text || '';
    // No closed label means no indicator at all outside opening hours.
    node.hidden = !text;
  };

  const updateAll = (root) => root.querySelectorAll('[data-contact-status]').forEach(update);

  updateAll(document);
  document.addEventListener('shopify:section:load', (event) => updateAll(event.target));
  setInterval(() => updateAll(document), 60000);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["legal-toc"] && !Shopify.designMode) return;
  try {
    (() => {
    const handleize = (text) =>
      text
        .toLowerCase()
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');

    const init = (section) => {
      const body = section.querySelector('[data-legal-body]');
      const toc = section.querySelector('[data-legal-toc]');
      const list = section.querySelector('[data-legal-toc-list]');
      if (!body || !toc || !list) return;

      const headings = Array.from(body.querySelectorAll('h2'));
      if (headings.length === 0) return;

      const used = new Set(Array.from(document.querySelectorAll('[id]')).map((el) => el.id));
      list.replaceChildren();

      headings.forEach((heading, index) => {
        const text = heading.textContent.trim();
        const article = text.match(/^artikel\s+(\d+[a-z]?)\b/i);
        let id = heading.id || (article ? `artikel-${article[1].toLowerCase()}` : handleize(text)) || `sectie-${index + 1}`;
        let candidate = id;
        let n = 2;
        while (used.has(candidate) && candidate !== heading.id) candidate = `${id}-${n++}`;
        heading.id = candidate;
        used.add(candidate);

        const item = document.createElement('li');
        item.className = 'page-legal__toc-item';
        const link = document.createElement('a');
        link.className = 'page-legal__toc-link';
        link.href = `#${candidate}`;

        if (article) {
          const num = document.createElement('span');
          num.className = 'page-legal__toc-num';
          num.textContent = article[1];
          const label = document.createElement('span');
          label.textContent = text.replace(/^artikel\s+\d+[a-z]?\s*[—–\-:.]?\s*/i, '') || text;
          link.append(num, label);
        } else {
          link.classList.add('page-legal__toc-link--plain');
          link.textContent = text;
        }

        item.appendChild(link);
        list.appendChild(item);
      });

      toc.hidden = false;

      // A deep link that arrived before the ids existed: jump now.
      if (location.hash) {
        const target = body.querySelector(location.hash.replace(/[^a-z0-9#_-]/gi, ''));
        if (target) target.scrollIntoView({ block: 'start' });
      }

      // Mark the article that is currently in view.
      const links = new Map(headings.map((h) => [h.id, list.querySelector(`a[href="#${h.id}"]`)]));
      let current = null;
      const setCurrent = (id) => {
        if (current === id) return;
        links.forEach((link, key) => {
          if (!link) return;
          if (key === id) link.setAttribute('aria-current', 'true');
          else link.removeAttribute('aria-current');
        });
        current = id;
      };

      // The current article is the last heading at or above the reading line:
      // just under the sticky header, where a jumped-to heading lands.
      let ticking = false;
      const update = () => {
        ticking = false;
        const header = parseFloat(getComputedStyle(document.body).getPropertyValue('--header-height')) || 0;
        const line = header + 40;
        let active = headings[0].id;
        headings.forEach((h) => {
          if (h.getBoundingClientRect().top <= line) active = h.id;
        });
        setCurrent(active);
      };
      const onScroll = () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(update);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      update();
    };

    document.querySelectorAll('.page-legal').forEach(init);
    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.querySelector('.page-legal');
      if (section) init(section);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-payment-promo"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__promoToggletip) return;
    window.__promoToggletip = true;
    const closeAll = (except) => {
      document.querySelectorAll('[data-promo-info][aria-expanded="true"]').forEach((button) => {
        if (button !== except) button.setAttribute('aria-expanded', 'false');
      });
    };
    document.addEventListener('click', (event) => {
      const button = event.target instanceof Element ? event.target.closest('[data-promo-info]') : null;
      closeAll(button);
      if (button) button.setAttribute('aria-expanded', String(button.getAttribute('aria-expanded') !== 'true'));
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeAll(null);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
